import React, { useState } from "react";
import { api } from "@/api";
import { useAuth } from "@/AuthContext";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Conta() {
  const { user, refresh } = useAuth();
  const [newEmail, setNewEmail] = useState(user?.email || "");
  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const [resetLink, setResetLink] = useState(null);

  const save = async () => {
    setBusy(true);
    try {
      const body = {};
      if (newEmail && newEmail !== user?.email) body.new_email = newEmail;
      if (newPwd) { body.new_password = newPwd; body.current_password = currentPwd; }
      if (Object.keys(body).length === 0) return toast.info("Nenhuma alteração");
      await api.put("/account/credentials", body);
      toast.success("Atualizado!");
      setCurrentPwd(""); setNewPwd("");
      await refresh();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro");
    } finally { setBusy(false); }
  };

  const requestReset = async () => {
    try {
      const r = await api.post("/auth/forgot-password", { email: user.email });
      setResetLink(r.data.reset_link);
      toast.success("Link de redefinição gerado");
    } catch {
      toast.error("Erro ao gerar link");
    }
  };

  return (
    <div className="space-y-8 max-w-xl" data-testid="conta-page">
      <div>
        <p className="label-tiny mb-2">Acesso</p>
        <h1 className="font-display text-4xl tracking-tight">Minha conta</h1>
        <p className="text-sm text-neutral-500 mt-1">Altere seu email ou senha de login.</p>
      </div>

      <Card className="p-6 border-[#E5E5E5] shadow-none space-y-4">
        <div>
          <Label>Email de login</Label>
          <Input type="email" value={newEmail} onChange={e=>setNewEmail(e.target.value)} data-testid="account-email-input"/>
        </div>
        <div className="border-t border-[#E5E5E5] pt-4 space-y-3">
          <p className="label-tiny">Trocar senha</p>
          <div><Label>Senha atual</Label><Input type="password" value={currentPwd} onChange={e=>setCurrentPwd(e.target.value)} data-testid="account-current-pwd"/></div>
          <div><Label>Nova senha</Label><Input type="password" value={newPwd} onChange={e=>setNewPwd(e.target.value)} data-testid="account-new-pwd"/></div>
        </div>
        <div className="flex justify-between items-center">
          <Button variant="outline" onClick={requestReset} data-testid="account-reset-button">Esqueci minha senha</Button>
          <Button onClick={save} disabled={busy} className="bg-[#0A0A0A] hover:bg-black text-white" data-testid="account-save-button">{busy ? "Salvando…" : "Salvar alterações"}</Button>
        </div>
        {resetLink && (
          <div className="border border-amber-200 bg-amber-50 p-3 rounded-md text-xs">
            <p className="font-medium mb-1">Link de redefinição (válido por 1h):</p>
            <code className="break-all text-[11px]">{window.location.origin}{resetLink}</code>
          </div>
        )}
      </Card>
    </div>
  );
}
